// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.drag-handle-icon[data-v-406e3c8c] {
    cursor: grab;
}

/* Optional: visual feedback when dragging */
.drag-handle-icon[data-v-406e3c8c]:active {
    cursor: grabbing;
}
`, "",{"version":3,"sources":["webpack://./src/common/DragHandle.vue"],"names":[],"mappings":";AAKA;IACA,YAAA;AACA;;AAEA,4CAAA;AACA;IACA,gBAAA;AACA","sourcesContent":["<template>\n    <i class=\"bi-grip-vertical drag-handle-icon\" />\n</template>\n\n<style scoped>\n.drag-handle-icon {\n    cursor: grab;\n}\n\n/* Optional: visual feedback when dragging */\n.drag-handle-icon:active {\n    cursor: grabbing;\n}\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
